import './offerList.css';
import get from 'lodash/get';
import OfferCard from '../OfferCard/OfferCard';
import Error from '../Error/Error';
import { useRateTable } from '../../hooks/useRateTable/useRateTable';
import type { RemoteConfiguration } from '@thesavingsgroup/remote-configuration/types/RemoteConfiguration';
import type { RateForDisplay } from '@thesavingsgroup/rate-table/types/RateForDisplay';
import { RateTableExternalError } from '@thesavingsgroup/rate-table/RateTableExternalError';
import AutopayLogo from '../../assets/Autopay-Logo.svg';
import RateGeniusLogo from '../../assets/RateGenius-Logo.svg';
import TreslLogo from '../../assets/Tresl-Logo.svg';
import type { Logger } from '@thesavingsgroup/logger/Logger';
import { useAnalytics } from '../../hooks/useAnalytics';

const OfferList = ({
  configuration,
  showOffers,
  logger,
  submittedLoanType,
}: {
  configuration: RemoteConfiguration;
  showOffers: boolean;
  logger: Logger;
  submittedLoanType: string;
}) => {
  if (!showOffers) {
    return null;
  }

  const { error, ratesSortedByBrand, version: ratesVersion } = useRateTable();
  const { sendSelectedRateCalcOffer } = useAnalytics(logger);

  const { title, copy } = error || {};

  const offerConfiguration =
    configuration[submittedLoanType as keyof RemoteConfiguration];

  const offerLogoMap: Record<string, string> = {
    autopay: AutopayLogo,
    rateGenius: RateGeniusLogo,
    tresl: TreslLogo,
  };

  return (
    <div className="offer-container">
      {error instanceof RateTableExternalError && (
        <Error title={title} copy={copy} />
      )}

      {!error &&
        offerConfiguration &&
        ratesSortedByBrand &&
        configuration.offerHeading && <h3>{configuration.offerHeading}</h3>}

      {offerConfiguration &&
        ratesSortedByBrand &&
        ratesSortedByBrand.map((rate: RateForDisplay) => (
          <OfferCard
            key={rate.brand}
            payment={rate.paymentAsString}
            apr={rate.aprAsString}
            brand={rate.brand}
            term={rate.loanTermAsString}
            loanAmount={rate.loanAmountAsString}
            logo={get(offerLogoMap, rate.brand, '')}
            redirectURL={get(offerConfiguration, rate.brand, '')}
            disclaimer={configuration.disclaimer}
            onViewDetailsClick={() =>
              sendSelectedRateCalcOffer({ brand: rate.brand, ratesVersion })
            }
          />
        ))}
    </div>
  );
};

export default OfferList;
